import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=36ba9d64&scoped=true&"
import script from "./UserDropdown.vue?vue&type=script&lang=ts&"
export * from "./UserDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./UserDropdown.vue?vue&type=style&index=0&id=36ba9d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ba9d64",
  null
  
)

export default component.exports
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtnDropdown,QAvatar,QSkeleton,QList,QItem,QItemSection,QIcon});qInstall(component, 'directives', {Ripple});
